import { getAxiosInstance } from "../blocks/axios/axiosFactory";
import { ChangePasswordRequest } from "../models/account/change-password/ChangePasswordRequest";
import { ForgotPasswordRequest } from "../models/account/forgot-password/ForgotPasswordRequest";
import JoinWithClientRequest from "../models/account/JoinWithClientRequest";
import { RegisterRequest } from "../models/account/register/RegisterRequest";
import { ResetPasswordRequest } from "../models/account/reset-password/ResetPasswordRequest";
import { UpdateUserRequest } from "../models/account/update-user/UpdateUserRequest";
import { VerifyActivationMailRequest } from "../models/account/verify-activation-mail/VerifyActivationMailRequest";
import { VerifyEmailRequest } from "../models/account/verify-email/VerifyEmailRequest";

const url = "/account";

export default class AccountService {
  static changeLanguage() {
    return getAxiosInstance().patch(`${url}/changeLanguage`);
  }

  static get() {
    return getAxiosInstance().get(`${url}/get`);
  }

  static getIsFullProfileActivationInProgress() {
    return getAxiosInstance().get(
      `${url}/getIsFullProfileActivationInProgress`,
    );
  }

  static register(request: RegisterRequest) {
    return getAxiosInstance().post(`${url}/register`, { ...request });
  }

  static forgotPassword(request: ForgotPasswordRequest) {
    return getAxiosInstance().post(`${url}/forgotPassword`, { ...request });
  }

  static resetPassword(request: ResetPasswordRequest) {
    return getAxiosInstance().post(`${url}/resetPassword`, { ...request });
  }

  static updateUser(request: UpdateUserRequest) {
    return getAxiosInstance().post(`${url}/updateUser`, { ...request });
  }

  static changePassword(request: ChangePasswordRequest) {
    return getAxiosInstance().post(`${url}/changePassword`, { ...request });
  }

  static verifyActivationMail(request: VerifyActivationMailRequest) {
    return getAxiosInstance().post(`${url}/verifyActivationMail`, {
      ...request,
    });
  }

  static verifyEmail(request: VerifyEmailRequest) {
    return getAxiosInstance().post(`${url}/verifyEmail`, { ...request });
  }

  static confirmUsageMediumChange(verificationCode: string) {
    return getAxiosInstance().patch(
      `${url}/confirmUsageMediumChange/${verificationCode}`,
    );
  }

  static joinWithClient(joinWithClientRequest: JoinWithClientRequest) {
    return getAxiosInstance().patch(
      `${url}/joinWithClient/${joinWithClientRequest.cardSerialNumber}/${joinWithClientRequest.identificationNumber}`,
    );
  }

  static refreshProfiles(clientId: number) {
    return getAxiosInstance().post(`${url}/refreshProfiles`, clientId); // ASP.NET Core trimma Async iz imena
  }
}
